<template>
  <div>
    
    <section class="main">
      <div class="">
        <div class="container">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-12">
              
              <div class="row">
                <div class="col-12 col-lg-6 offset-lg-3 pb-3 fG text-center">
                  <h1 class="fXG">Reportes</h1>
                  
                </div>
              </div>
              
              <div class="row">
                <div class="col-12 text-center white fG pb-3">
                  <span class="bold">Para comenzar,</span> inicia sesión.
                </div>
                <!-- <div class="col-12 text-center white fG pb-3">
                  <a href class="btn btnfb">
                    <i class="fab fa-facebook-square"></i> Inicia con
                    <span class="bold">Facebook</span>
                  </a>
                </div>-->
                <!-- <div class="col-12 text-center white fG pb-3">ó</div> -->
              </div>
              <div class="row pb-3">
                <div class="formulario col-12 col-lg-6 offset-lg-3 pt-2 pb-4">
                  <form method="post" @submit="submitFormulario($event)">
                    <label>
                      <input
                        type="text"
                        v-model="user"
                        maxlength="100"
                        placeholder="Nombre de usuario"
                        required
                      />
                    </label>

                    <label class="m-0">
                      <input
                        type="password"
                        v-model="password"
                        maxlength="100"
                        placeholder="Contraseña"
                        required
                      />
                    </label>

                    <div class="d-flex py-3">
                      
                      <div class="col-12 ">
                        <div class="text-center pt-2">
                          <button type="submit" class="submit btn btnsup w-100 mx-auto">Entrar</button>
                        </div>
                      </div>
                    </div>

                    
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Footer from "../Components/Footer.vue";

export default {
  name: "AcademiaDigital",
  props: {
    msg: String
  },
  data() {
    return {
      user: "",
      password: "",
      redirect_url: ""
    };
  },
  mounted: function() {
    

    AOS.init();

    
  },
  components: {
   
    "footer-mx": Footer
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        user: this.user,
        password: this.password
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "login-reportes.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              //this.$store.state.user = this.$cookie.get("useracademiadigital");

              localStorage.setItem("useracademiadigitalreportes", JSON.stringify(res.user));
              this.$store.state.user_reportes = JSON.stringify(res.user);

              this.$router.push("/administrador/dashboard");
              

            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");

            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

